export default __webpack_public_path__ + "static/media/ATBA.a99186d0.png";